import { ApiError } from '../api/client';
import type { TranslationFunction, TranslationKey } from './translations';

const apiErrorKeys: Record<string, TranslationKey> = {
  VALIDATION_FAILED: 'error.validationFailed',
  AUTH_TOKEN_MISSING: 'error.authTokenMissing',
  AUTH_SESSION_INVALID: 'error.authSessionInvalid',
  AUTH_CONTEXT_REQUIRED: 'error.authContextRequired',
  AUTH_CONTEXT_FORBIDDEN: 'error.authContextForbidden',
  AUTH_CREDENTIALS_INVALID: 'error.authCredentialsInvalid',
  AUTH_USER_INACTIVE: 'error.authUserInactive',
  AUTH_REFRESH_INVALID: 'error.authRefreshInvalid',
  AUTH_PROVIDER_INVALID: 'error.authProviderInvalid',
  AUTH_PROVIDER_NOT_CONFIGURED: 'error.authProviderNotConfigured',
  AUTH_EMAIL_TAKEN: 'error.authEmailTaken',
  REGISTRATION_SERVICE_INVALID: 'error.registrationServiceInvalid',
  RATE_LIMIT_EXCEEDED: 'error.rateLimitExceeded',
  PROFESSIONAL_SEARCH_FORBIDDEN: 'error.professionalSearchForbidden',
  PROFESSIONAL_DETAIL_FORBIDDEN: 'error.professionalDetailForbidden',
  PROFESSIONAL_UPDATE_FORBIDDEN: 'error.professionalUpdateForbidden',
  ASSIGNMENT_CONTEXT_INVALID: 'error.assignmentContextInvalid',
  ASSIGNMENT_TIME_RANGE_INVALID: 'error.assignmentTimeRangeInvalid',
  ASSIGNMENT_CREATE_FAILED: 'error.assignmentCreateFailed',
  ASSIGNMENT_NOT_FOUND: 'error.assignmentNotFound',
  ASSIGNMENT_RESPONSE_FORBIDDEN: 'error.assignmentResponseForbidden',
  ASSIGNMENT_STATUS_INVALID: 'error.assignmentStatusInvalid',
  ASSIGNMENT_TIME_CONFLICT: 'error.assignmentTimeConflict',
  PROFESSIONAL_NOT_FOUND: 'error.professionalNotFound',
  PROFESSIONAL_EXTERNAL_REQUESTS_DISABLED: 'error.externalRequestsDisabled',
  SERVICE_NOT_OFFERED: 'error.serviceNotOffered',
  AVAILABILITY_FORBIDDEN: 'error.availabilityForbidden',
  AVAILABILITY_NOT_FOUND: 'error.availabilityNotFound',
  AVAILABILITY_TIME_RANGE_INVALID: 'error.availabilityTimeRangeInvalid',
  PUSH_TOKEN_NOT_FOUND: 'error.pushTokenNotFound'
};

/** Übersetzt strukturierte API-Fehler und fällt bei unbekannten Antworten kontrolliert zurück. */
export function localizedApiError(
  reason: unknown,
  t: TranslationFunction,
  fallbackKey: TranslationKey
): string {
  if (reason instanceof ApiError && reason.code) {
    const translationKey = apiErrorKeys[reason.code];
    if (translationKey) return t(translationKey);
  }
  return t(fallbackKey);
}
